export enum PrintType {
    KitchenBons = 'kitchen-bon',
    Receipts = 'receipt',
    DeliveryTickets = 'delivery-ticket',
    ShiftCloseouts = 'shift-closeout',
}

export enum PrintJobType {
    KitchenBon = 'kitchen-bon',
    DeliveryTicket = 'delivery-ticket',
    Receipt = 'receipt',
    OpenTabSubmissionBon = 'open-tab-submission-bon',
    ShiftCloseout = 'shift-closeout',
}

export enum ReceiptType {
    Original = 'original',
    Cancellation = 'cancellation',
}

export enum ConnectionType {
    Network = 'network',
    SunmiDefault = 'sunmi-default',
}

export enum ErrorCode {
    NetworkError = 'network.error',
    NetworkTimeout = 'network.timeout',
    SunmiPrinterUnavailable = 'sunmi.unavailable',
    SunmiPrinterOperation = 'sunmi.operation',
}

export const connectionTypes = [ConnectionType.Network, ConnectionType.SunmiDefault]

export const printTypes = [
    PrintType.KitchenBons,
    PrintType.Receipts,
    PrintType.DeliveryTickets,
    PrintType.ShiftCloseouts,
] as const

export const printTypeByPrintJobType: Record<PrintJobType, PrintType> = {
    [PrintJobType.KitchenBon]: PrintType.KitchenBons,
    [PrintJobType.OpenTabSubmissionBon]: PrintType.KitchenBons,
    [PrintJobType.Receipt]: PrintType.Receipts,
    [PrintJobType.ShiftCloseout]: PrintType.ShiftCloseouts,
    [PrintJobType.DeliveryTicket]: PrintType.DeliveryTickets,
}

export const paperWidths: readonly number[] = [58, 80] as const

export const charsPerLine: readonly number[] = [32, 48] as const
